import { GenerateQueriesArgs, generateQueries } from 'src/queries/queryGenerator'
import { BuyerCompanyAsBuyer } from 'src/types'

export const BUYER_COMPANIES_ENDPOINT = 'buyer/buyer_companies'
export const BUYER_COMPANIES_QUERY_KEY = 'buyerCompanies'

export interface GetBuyerCompaniesRequest {
  buyerCompanyId?: Id
}

const generateQueriesConfig: GenerateQueriesArgs<BuyerCompanyAsBuyer, GetBuyerCompaniesRequest> = {
  endpoint: BUYER_COMPANIES_ENDPOINT,
  queryKey: BUYER_COMPANIES_QUERY_KEY,
}

export const { useSingleEntityQuery: useBuyerCompanyQuery } = generateQueries(generateQueriesConfig)
